import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const DesignBoardModalContainer: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        padding: pxToRem(24),
        margin: 0,
        width: pxToRem(450),
        borderTop: 'unset',
    },
});

export const DesignBoardModalHeader: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Medium65,
    [theme.screen.tablet]: {
        fontSize: pxToRem(22),
        marginBottom: pxToRem(34),
        marginTop: pxToRem(16),
    },
});

export const DesignBoardModalBody: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Roman55,

    [theme.screen.tablet]: {
        fontSize: pxToRem(16),
        lineHeight: 1.3,
        marginBottom: pxToRem(34),
    },
});

export const DesignBoardModalButton: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        width: pxToRem(143),
    },
});
